import { Description } from '@casavo/base-ui'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { Titles } from '@/types/cate-graphql-generated-types'
import getTranslatedTitle from '@/utils/get-translated-title'

import CasavoLogoSmall from '../Icon/CasavoLogoSmall'

type Props = {
  className?: string
  hideLogo?: boolean
  titles: Array<Titles>
}

const CasavoPropertyTitle: React.FC<Props> = ({ className, hideLogo = false, titles }) => {
  const { lang } = useTranslation()
  return (
    <div
      className={cn(
        sprinkles({
          alignItems: 'center',
          display: 'flex',
          gap: 's-m',
          paddingBottom: 'm',
        }),
        className
      )}
      data-testid="casavo-property-title"
    >
      {!hideLogo && <CasavoLogoSmall aria-hidden="true" className={sprinkles({ flexShrink: 0 })} width={16} />}
      <Description color="greyscale500">{getTranslatedTitle(titles, lang)}</Description>
    </div>
  )
}

export default CasavoPropertyTitle
